<template>
  <span
    class="inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-600/20"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "InfoBadge",
  props: ["label"],
};
</script>
